module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "displya-none-m"
  }, [_c('div', [_c('ul', {
    staticClass: "nev-desk"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "linev nev-url-d"
  }, [_c('ul', {
    staticClass: "ul-nev-url"
  }, [_c('li', {
    staticClass: "ulli-url"
  }, [_c('router-link', {
    staticClass: "link-url",
    attrs: {
      "to": "/videos"
    }
  }, [_vm._v("VIDEOS")])], 1), _vm._v(" "), _c('li', {
    staticClass: "ulli-url"
  }, [_c('router-link', {
    staticClass: "link-url",
    attrs: {
      "to": "/documents"
    }
  }, [_vm._v("MANUALS")])], 1), _vm._v(" "), _c('li', {
    staticClass: "ulli-url"
  }, [_c('router-link', {
    staticClass: "link-url",
    attrs: {
      "to": "/products-view"
    }
  }, [_vm._v("PRODUCTS")])], 1), _vm._v(" "), _c('li', {
    staticClass: "ulli-url"
  }, [_c('router-link', {
    staticClass: "link-url",
    attrs: {
      "to": "/favourite"
    }
  }, [_vm._v("FAVOURITES")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "linev nev-cart-d"
  }, [_c('md-badge', {
    attrs: {
      "md-content": _vm.itemCount
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.showCart
    }
  }, [_c('md-icon', [_vm._v("shopping_cart")])], 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "linev nev-search-d"
  }, [_c('div', {
    staticClass: "mainSearchBar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeyWord),
      expression: "searchKeyWord"
    }],
    staticClass: "searchTerm searchMain",
    attrs: {
      "type": "text",
      "placeholder": "What are you looking for?"
    },
    domProps: {
      "value": (_vm.searchKeyWord)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.SearchItems.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeyWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mainSearchButton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SearchItems()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "linev nev-pro-d"
  }, [_c('md-menu', {
    attrs: {
      "md-size": "medium",
      "md-align-trigger": ""
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [(this.proIMG != null) ? _c('md-avatar', [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_other/profile/' + this.proIMG,
      "alt": "User profile image"
    }
  })]) : _c('md-avatar', [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/pro1.jpg",
      "alt": "User profile image"
    }
  })])], 1), _vm._v(" "), _c('md-menu-content', {
    staticClass: "my-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/team"
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("supervised_user_circle")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Team")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/order-history"
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("shopping_cart")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Order History")])], 1)], 1), _vm._v(" "), (_vm.isSupervisor) ? _c('router-link', {
    attrs: {
      "to": "/requested-list"
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("local_mall")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Requested List")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("account_circle")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Profile")])], 1)], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://launch-app.rcpanz.com/contactus/",
      "target": "_blank"
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("perm_phone_msg")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Contact Us")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logOut.apply(null, arguments)
      }
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("lock")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "nav-gap-d"
  })]), _vm._v(" "), _c('div', {
    staticClass: "displya-none-D"
  }, [_c('div', {
    staticClass: "nev-mobile sticky"
  }, [_c('div', {
    staticClass: "nev-right-m"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "10%",
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "dropbtn",
    on: {
      "click": function($event) {
        return _vm.myFunction()
      }
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content",
    attrs: {
      "id": "myDropdown"
    }
  }, [_c('router-link', {
    staticClass: "drop-ttx",
    attrs: {
      "to": "/team"
    }
  }, [_c('md-icon', [_vm._v("supervised_user_circle")]), _vm._v("  "), _c('span', [_vm._v("Team")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "drop-ttx",
    attrs: {
      "to": "/products"
    }
  }, [_c('md-icon', [_vm._v("shopping_cart")]), _vm._v("  "), _c('span', [_vm._v("Products")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "drop-ttx",
    attrs: {
      "to": "/profile"
    }
  }, [_c('md-icon', [_vm._v("account_circle")]), _vm._v("  "), _c('span', [_vm._v("Profile ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "lgout drop-ttx",
    on: {
      "click": _vm.logOut
    }
  }, [_c('md-icon', [_vm._v("lock")]), _vm._v("  "), _c('span', [_vm._v(" Logout ")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticClass: "mainSearchBar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeyWord),
      expression: "searchKeyWord"
    }],
    staticClass: "searchTerm searchMain",
    attrs: {
      "type": "text",
      "placeholder": "What are you looking for?"
    },
    domProps: {
      "value": (_vm.searchKeyWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeyWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$router.resolve({
        path: '/search-items?search=' + _vm.searchKeyWord
      }).href
    }
  }, [_vm._m(1)])])])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "gap-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-mb"
  }, [_c('ul', {
    staticClass: "ft-bar"
  }, [_c('li', {
    staticClass: "ft-icon"
  }, [_c('router-link', {
    staticClass: "ft-txt",
    attrs: {
      "to": "/videos"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play ft-icon-fa",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v("VIDEOS")])], 1), _vm._v(" "), _c('li', {
    staticClass: "ft-icon"
  }, [_c('router-link', {
    staticClass: "ft-txt",
    attrs: {
      "to": "/documents"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text ft-icon-fa",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v(" MANUALS")])], 1), _vm._v(" "), _c('li', {
    staticClass: "ft-icon"
  }, [_c('router-link', {
    staticClass: "ft-txt",
    attrs: {
      "to": "/catelogue"
    }
  }, [_c('i', {
    staticClass: "fa fa-book ft-icon-fa",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v("CATALOGUE")])], 1), _vm._v(" "), _c('li', {
    staticClass: "ft-icon"
  }, [_c('router-link', {
    staticClass: "ft-txt",
    attrs: {
      "to": "/favourite"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart ft-icon-fa",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v("FAVOURITES")])], 1)])])]), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.newModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.newModal = $event
      },
      "update:md-active": function($event) {
        _vm.newModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Recommend to Supervisor\n       "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.newModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n         ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from-padding modal-width-100",
    attrs: {
      "id": "form",
      "onsubmit": "return false;"
    }
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [(this.cartItemList.length > 0) ? _c('div', {
    staticClass: "delete_all_crt"
  }, [(this.cartItemList.length > 1) ? _c('md-checkbox', {
    staticStyle: {
      "margin": "0px 20px 0 0"
    },
    on: {
      "change": function($event) {
        return _vm.toggleAll($event)
      }
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {}, [(this.selectdIds.length > 0) ? _c('button', {
    staticClass: "btn delete_btn-my",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.MultipleDelete
    }
  }, [_vm._v("\n                 Delete\n               ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.cartItemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cart_list_user"
    }, [(_vm.cartItemList.length > 1) ? _c('div', [_c('md-checkbox', {
      staticStyle: {
        "margin": "10px"
      },
      attrs: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.checkList($event)
        }
      },
      model: {
        value: (_vm.selectdIds),
        callback: function($$v) {
          _vm.selectdIds = $$v
        },
        expression: "selectdIds"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item_image_cart_user"
    }, [_c('img', {
      attrs: {
        "src": item.product_details.thumbnail_medium
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item_data_cart_user"
    }, [_c('p', {
      staticClass: "pr_title_user"
    }, [_vm._v(_vm._s(item.product_details.name))]), _vm._v(" "), _vm._l((item), function(item, index) {
      return _c('div', {
        key: index
      }, [(item != null && index != 'product_id' && index != 'id' && index != 'product_details' && index != 'product_description' && index != 'product_type_id' && index != 'qty' && index != 'status' && index != 'modify' && index != 'color' && index != 'product_color_id' && index != 'product_item_id' && index != 'logs') ? _c('p', {
        staticClass: "pr_datas_user"
      }, [_vm._v("\n                   " + _vm._s(_vm.convertToString(index) + ' = ' + item) + "\n                 ")]) : _vm._e()])
    }), _vm._v(" "), _c('p', {
      staticClass: "pr_datas_user"
    }, [_vm._v("\n                     Color = " + _vm._s(item.color.name) + "\n                 ")])], 2), _vm._v(" "), _c('div', {
      staticClass: "item_data_qty_user"
    }, [_c('div', {
      staticClass: "delete_crt"
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      on: {
        "click": function($event) {
          return _vm.removeCartItem(item.id)
        }
      }
    }, [_c('md-icon', {
      staticStyle: {
        "font-size": "16px !important"
      }
    }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('p', [_vm._v("Quantity")]), _vm._v(" "), _c('vue-numeric-input', {
      attrs: {
        "min": 1,
        "step": 1,
        "align": "center",
        "controls-type": "plusminus"
      },
      on: {
        "input": function($event) {
          return _vm.handleBlur(index, item.qty)
        }
      },
      model: {
        value: (item.qty),
        callback: function($$v) {
          _vm.$set(item, "qty", $$v)
        },
        expression: "item.qty"
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('div', {
    staticClass: "custom-modal-footer-items"
  }, [_vm._v("\n               \n            "), (_vm.isChangeQTY) ? _c('button', {
    staticClass: "btn default_btn-my",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveCart
    }
  }, [_vm._v("\n              Save Cart\n            ")]) : _vm._e(), _vm._v("   \n            "), _c('button', {
    staticClass: "btn primary-btn-my",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.proceedCart
    }
  }, [_vm._v("\n              Proceed\n            ")])]), _vm._v(" "), (_vm.isChangeQTY) ? _c('div', {
    staticClass: "error-acction custom-modal-footer-items"
  }, [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n              Please click the "), _c('b', [_vm._v("Save Cart")]), _vm._v(" button before you leave.\n            ")])]) : _vm._e()])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "linev nev-img-d"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "/static/img/crp-images/Logo_RCP_Smart_App.png",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mainSearchButton",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nev-left-m"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "nev-imglg",
    attrs: {
      "src": "/static/img/crp-images/Logo_RCP_Smart_App.png",
      "alt": "Logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328fc681"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/layout/UserDashHeader.vue
// module id = 2083
// module chunks = 1